import React, { useState, useEffect } from 'react';
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  TextField,
  Typography,
  Button,
  FormHelperText,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useFormik } from 'formik';
import { useAlert } from 'react-alert';

import { isMobile } from 'react-device-detect';

import PhoneInput from '../atoms/PhoneInput';

const useStyles = makeStyles((_theme) => ({
  paper: {
    width: '100%',

    marginBottom: 0,
    padding: _theme.spacing(2),
  },
  root: {
    //   width: '100%',
    //   margin: theme.spacing(2),
    backgroundColor: 'gray',
    //   '& > *': {
    //     margin: theme.spacing(1),
    //   },
  },
  formGroup: { marginTop: _theme.spacing(1) },
  countPaper: {},
  // textField: { backgroundColor: 'white' },
}));

const ReservationForm = ({
  onSubmit,
  editData,
  visibleAlert = true,
  isDialog = false,
}) => {
  const alert = useAlert();
  const theme = useTheme();
  const [isEditMode, setIsEditMode] = useState(!!editData);
  const validate = (values) => {
    const errors = {};

    if (!values.name) {
      errors.name = '이름을 입력해주세요';
    } else if (values.name.length > 20) {
      errors.name = '이름이 너무 깁니다';
    }

    const normalizedPhone = values.phone.replace(/_/g, '').replace(/-/g, '');

    if (!values.phone) {
      errors.phone = '휴대폰번호를 입력해주세요';
    } else if (normalizedPhone.length !== 10 && normalizedPhone.length !== 11) {
      errors.phone = '휴대폰번호를 확인해주세요';
    }

    if (values.content && values.content.length > 1500) {
      errors.content = '내용이 너무 깁니다';
    }

    if (!values.isAgreePolicy) {
      errors.isAgreePolicy = '약관에 동의해주세요';
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      phone: '',
      content: '',
      isAgreePolicy: false,
    },
    validate,
    onSubmit: (values) => {
      if (typeof window === 'undefined') return;

      window.grecaptcha.ready(async () => {
        const {
          name, phone, content, isAgreePolicy,
        } = values;
        // needs for recaptacha ready

        // do request for recaptcha token
        // response is promise with passed token

        const recaptchaToken = await window.grecaptcha.execute(
          `${process.env.REACT_APP_RECAPTCHA_KEY}`,
          {
            action: 'create_reservation',
          },
        );

        const formData = new FormData();
        formData.append('name', name);
        formData.append('phone', phone);
        formData.append('title', '온라인 상담 신청합니다.');
        formData.append('content', content);
        formData.append('is_agree_policy', isAgreePolicy);
        formData.append('g-recaptcha-response', recaptchaToken);

        // form 데이터를 json으로 변경한다
        const data = {};
        formData.forEach((value, key) => {
          data[key] = value;
        });
        const json = JSON.stringify(data);

        // submit to Server
        let response = null;
        if (isEditMode) {
          response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/reservation/${editData.id}`,
            {
              method: 'PUT',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json; charset=utf-8',
              },
              body: json,
            },
          );
        } else {
          response = await fetch(
            `${process.env.REACT_APP_API_URL}/api/reservation`,
            {
              method: 'POST',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json; charset=utf-8',
              },
              body: json,
            },
          );
        }

        if (
          response.status === 200
          || response.status === 201
          || response.status === 204
        ) {
          alert.show('순서대로 연락 드리고 있습니다!', 'success');
          alert.show('조금만 기다려주세요^^', 'success');

          formik.resetForm();
          if (onSubmit) onSubmit();
        } else if (response.status === 406) {
          alert.show('입력 내용을 확인해주세요.', 'error');
        } else {
          alert.show('고객센터에 문의부탁드립니다.', 'error');
        }
      });
    },
  });

  useEffect(() => {
    const { setValues } = formik;
    if (editData) {
      setIsEditMode(true);
      const {
        name, phone, content, is_agree_policy: isAgreePolicy,
      } = editData;

      setValues({
        name, phone, content, isAgreePolicy,
      });
    }
  }, [editData]);

  const classes = useStyles(theme);

  const handlePolicyClick = () => {
    if (typeof window !== 'undefined') {
      window.open(
        '/policy',
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400',
      );
    }
  };

  const { handleChange, touched, errors } = formik;
  const {
    name, phone, content, isAgreePolicy,
  } = formik.values;

  const renderCheckBox = () => (
    <Checkbox
      required
      id="isAgreePolicy"
      checked={isAgreePolicy}
      onChange={handleChange}
      value={isAgreePolicy}
    />
  );

  const renderCheckBoxLabel = () => (
    <>
      <span className="noselect">개인정보 취급방침 동의 </span>
      <Button onClick={handlePolicyClick}>[자세히보기]</Button>
    </>
  );

  return (
    <>
      {!isDialog && (
        <div
          style={{
            marginTop: '20px',
            height: '50px',
            backgroundColor: theme.palette.primary.main,
            lineHeight: '50px',
            textAlign: 'center',
          }}
        >
          <span
            className="noselect"
            style={{
              fontSize: '18px',
              color: theme.palette.primary.contrastText,
              width: '100%',
            }}
          >
            무료상담신청
          </span>
        </div>
      )}
      <Paper className={classes.paper}>
        {/* <Typography variant="h4"> 온라인 상담 신청</Typography>
          <br /> */}
        {visibleAlert && (
          <Typography className="noselect">
            <span style={{ color: 'red' }}>
              <b>유의사항</b>
              {' '}
              <br />
              - 줄눈시공은 절대 청소당일 청소와 같이
              진행 하시면 안됩니다.
              {' '}
              <br />
              - 최소 청소 1일전,1일후 시공
              가능합니다.
              {' '}
              <br />
              - 물기나 습기가 남아있으면 줄눈의 변색이나
              탈락의 원인이 됩니다
            </span>
          </Typography>
        )}

        <form
          className={classes.form}
          noValidate
          autoComplete="off"
          style={isMobile ? { height: '100%' } : {}}
        >
          <FormGroup className={classes.formGroup}>
            <FormControl>
              <TextField
                required
                type="text"
                label="이름"
                id="name"
                value={name}
                variant="outlined"
                onChange={handleChange}
                inputProps={{
                  readOnly: isEditMode,
                  maxLength: 20,
                }}
                error={!!(touched.name && errors.name)}
                helperText={touched.name && errors.name ? errors.name : ''}
              />
            </FormControl>
          </FormGroup>
          <FormGroup className={classes.formGroup}>
            <FormControl>
              <PhoneInput
                required
                readOnly={isEditMode}
                error={!!(touched.phone && errors.phone)}
                helperText={touched.phone && errors.phone ? errors.phone : ''}
                id="phone"
                value={phone}
                onChange={handleChange}
                variant="outlined"
              />
            </FormControl>
          </FormGroup>
          <FormGroup className={classes.formGroup}>
            <FormControl className={classes.formControl}>
              <TextField
                id="content"
                label="내용"
                multiline
                rows="4"
                inputProps={{
                  maxLength: 1500,
                }}
                variant="outlined"
                value={content}
                onChange={handleChange}
                error={!!(touched.content && errors.content)}
                helperText={
                  touched.content && errors.content ? errors.content : ''
                }
              />
            </FormControl>
          </FormGroup>

          <FormControl
            required
            error={errors.isAgreePolicy}
            component="fieldset"
          >
            <FormGroup className={classes.formGroup}>
              <FormControlLabel
                control={renderCheckBox()}
                label={renderCheckBoxLabel()}
              />
            </FormGroup>
            {touched.isAgreePolicy && errors.isAgreePolicy && (
              <FormHelperText>{errors.isAgreePolicy}</FormHelperText>
            )}
          </FormControl>

          <Button
            fullWidth
            color="secondary"
            size="large"
            variant="contained"
            style={{ marginTop: '20px', color: theme.palette.secondary.contrastText }}
            onClick={formik.handleSubmit}
          >
            확인
          </Button>
        </form>
      </Paper>
    </>
  );
};

ReservationForm.propTypes = {};

export default ReservationForm;
